module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Storm-5a3cd99c5ba96bff6001e47167513411.svg";